<section class="flex flex-col font-display">
  <span class="text-2xl sm:text-3xl font-bold">Create Reimbursement</span>
  <form
    [formGroup]="form"
    class="w-full flex flex-col gap-6 mt-6 p-4 lg:flex-row lg:gap-8"
  >
    <div class="w-full lg:w-2/3 grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div class="flex flex-col space-y-2 lg:col-span-2">
        <span class="font-medium">Title</span>
        <div class="w-full flex flex-col space-y-1">
          <input
            type="text"
            formControlName="title"
            class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
            placeholder="Masukkan judul"
            [ngClass]="{
              'ring-red-500 ring-1':
                form.get('title')?.invalid && form.get('title')?.touched
            }"
          />
          <span
            *ngIf="form.get('title')?.invalid && form.get('title')?.touched"
            class="text-red-500 text-xs"
            >Title is required</span
          >
        </div>
      </div>
      <div class="flex flex-col space-y-2 lg:col-span-2">
        <span class="font-medium">Expense Category</span>
        <div class="w-full flex flex-col space-y-1">
          <mat-select
            (selectionChange)="setMaxAmount($event)"
            type="text"
            formControlName="expanseCategoryId"
            class="!w-full h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
            placeholder="Pilih kategori expense"
            [ngClass]="{
              'ring-red-500 ring-1':
                form.get('expanseCategoryId')?.invalid &&
                form.get('expanseCategoryId')?.touched
            }"
          >
            <ng-container *ngFor="let item of expenseCategory">
              <mat-option class="!text-sm !font-display" [value]="item.id">{{
                item.name
              }}</mat-option>
            </ng-container>
          </mat-select>
          <span
            *ngIf="
              form.get('expanseCategoryId')?.invalid &&
              form.get('expanseCategoryId')?.touched
            "
            class="text-red-500 text-xs"
            >Expense Category is required</span
          >
        </div>
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Amount</span>
        <div class="w-full flex flex-col space-y-1">
          <input
            [readonly]="!this.form.get('expanseCategoryId')?.value"
            formatNumber
            formatCurrency
            type="text"
            formControlName="amount"
            class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
            placeholder="Masukkan nominal"
            [ngClass]="{
              'ring-red-500 ring-1':
                form.get('amount')?.invalid && form.get('amount')?.touched,
              'bg-gray-100': !this.form.get('expanseCategoryId')?.value
            }"
          />
          <span
            *ngIf="form.get('amount')?.invalid && form.get('amount')?.touched"
            class="text-red-500 text-xs"
            >Amount is required or not allowed above than category's
            budget</span
          >
        </div>
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Currency</span>
        <div class="w-full flex flex-col space-y-1">
          <mat-select
            type="text"
            formControlName="currency"
            class="!w-full h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
            placeholder="Pilih mata uang"
            [ngClass]="{
              'ring-red-500 ring-1':
                form.get('currency')?.invalid && form.get('currency')?.touched
            }"
          >
            <mat-option
              value="Rp"
              class="!font-display !text-sm !tracking-normal"
              >Rupiah</mat-option
            >
            <mat-option
              value="USD"
              class="!font-display !text-sm !tracking-normal"
              >US Dollar</mat-option
            >
            <mat-option
              value="SGD"
              class="!font-display !text-sm !tracking-normal"
              >Singapore Dollar</mat-option
            >
          </mat-select>
          <span
            *ngIf="
              form.get('currency')?.invalid && form.get('currency')?.touched
            "
            class="text-red-500 text-xs"
            >Currency is required</span
          >
        </div>
      </div>
      <div class="flex flex-col space-y-2 lg:col-span-2">
        <span class="font-medium">Receipt Date</span>
        <div class="w-full flex flex-col space-y-1">
          <input
            type="date"
            formControlName="date"
            class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
            placeholder="Pilih tanggal kwitansi"
            [ngClass]="{
              'ring-red-500 ring-1':
                form.get('date')?.invalid && form.get('date')?.touched
            }"
          />
          <span
            *ngIf="form.get('date')?.invalid && form.get('date')?.touched"
            class="text-red-500 text-xs"
            >Receipt Date is required</span
          >
        </div>
      </div>
      <div class="flex flex-col space-y-2 lg:col-span-2">
        <span class="font-medium">Tag</span>
        <div class="w-full flex flex-col space-y-1">
          <mat-select
            type="text"
            formControlName="tagId"
            (openedChange)="onTagSelectOpenedChange($event)"
            class="!w-full h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
            placeholder="Pilih tag"
            [ngClass]="{
              'ring-red-500 ring-1':
                form.get('tagId')?.invalid && form.get('tagId')?.touched
            }"
          >
            <mat-option
              [value]="null"
              (onSelectionChange)="$event.source.deselect()"
            >
              <input
                type="text"
                [(ngModel)]="tagSearchTerm"
                [ngModelOptions]="{ standalone: true }"
                (mousedown)="$event.stopPropagation()"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
                class="h-9 w-full rounded-md text-sm px-3 text-[#5C5C5C] border border-gray-200 focus:outline-none"
                placeholder="Search Tag Project"
              />
            </mat-option>
            <ng-container *ngFor="let item of filteredTag">
              <mat-option [value]="item.id">{{ item.name }}</mat-option>
            </ng-container>
          </mat-select>
          <span
            *ngIf="form.get('tagId')?.invalid && form.get('tagId')?.touched"
            class="text-red-500 text-xs"
            >Tag is required</span
          >
        </div>
        <div
          *ngIf="canCreateProjectTag"
          class="mt-3 rounded-lg border border-gray-200 p-3"
        >
          <span class="text-xs font-medium text-[#5C5C5C]">Tambah Tag Nomor Project</span>
          <div class="mt-2 grid grid-cols-1 gap-2 sm:grid-cols-2">
            <input
              type="text"
              [(ngModel)]="projectTagNumber"
              [ngModelOptions]="{ standalone: true }"
              class="h-10 w-full rounded-lg text-sm px-3 text-[#5C5C5C] border border-gray-200 focus:outline-none"
              placeholder="Nomor Project"
            />
            <input
              type="text"
              [(ngModel)]="projectTagName"
              [ngModelOptions]="{ standalone: true }"
              class="h-10 w-full rounded-lg text-sm px-3 text-[#5C5C5C] border border-gray-200 focus:outline-none"
              placeholder="Nama Project"
            />
          </div>
          <button
            type="button"
            (click)="createProjectTag()"
            class="mt-2 h-10 w-full rounded-lg bg-[#42A5CE] text-white text-sm"
          >
            Tambah Tag Project
          </button>
        </div>
      </div>
      <div class="flex flex-col space-y-2 mt-4 lg:col-span-2">
        <span class="font-medium">Description</span>
        <div class="w-full flex flex-col space-y-1">
          <textarea
            type="text"
            formControlName="description"
            class="w-full h-32 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
            placeholder="Masukkan deskripsi"
            [ngClass]="{
              'ring-red-500 ring-1':
                form.get('description')?.invalid &&
                form.get('description')?.touched
            }"
          ></textarea>
          <span
            *ngIf="
              form.get('description')?.invalid &&
              form.get('description')?.touched
            "
            class="text-red-500 text-xs"
            >Description is required</span
          >
        </div>
      </div>
      <div class="col-span-1 sm:lg:col-span-2 py-6">
        <mat-divider class="!border-gray-300"></mat-divider>
      </div>
      <div class="flex flex-col space-y-2 lg:col-span-2">
        <span class="font-medium">Select Location</span>
        <div class="w-full flex flex-col space-y-1">
          <input
            type="text"
            formControlName="location"
            class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
            placeholder="Masukkan lokasi"
            [ngClass]="{
              'ring-red-500 ring-1':
                form.get('location')?.invalid && form.get('location')?.touched
            }"
          />
          <span
            *ngIf="
              form.get('location')?.invalid && form.get('location')?.touched
            "
            class="text-red-500 text-xs"
            >Location is required</span
          >
        </div>
      </div>
      <div
        class="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 mt-8 col-span-1 sm:lg:col-span-2"
      >
        <button
          type="button"
          (click)="submit('Sent')"
          class="w-full sm:w-80 h-12 rounded-lg bg-[#85E2B1] text-white flex items-center justify-center space-x-2"
        >
          <span>Submit</span>
        </button>
        <button
          type="button"
          (click)="submit('Draft')"
          class="w-full sm:w-80 h-12 rounded-lg bg-gray-400 text-white flex items-center justify-center space-x-2"
        >
          <span>Save to Draft</span>
        </button>
      </div>
    </div>
    <div class="w-full lg:w-1/3 flex flex-col space-y-2">
      <span class="font-medium">Attachment </span>
      <input
        type="file"
        #file
        name="file"
        class="hidden"
        multiple
        (change)="uploadFile($event)"
      />
      <div
        class="h-72 sm:h-96 w-full sm:w-72 rounded-lg border border-gray-200 flex flex-col items-center justify-center"
      >
        <i class="fa-solid fa-file text-6xl" *ngIf="!uploadStatus"></i>
        <mat-spinner [diameter]="50" *ngIf="uploadStatus"></mat-spinner>
        <span
          class="mt-2 text-xs break-words whitespace-normal text-center w-full px-2"
          *ngIf="fileExists && !uploadStatus"
          >{{ this.fileName }}</span
        >
      </div>
      <button
        type="button"
        class="w-full sm:w-72 h-12 flex items-center justify-center rounded-lg border border-gray-400"
        (click)="file.click()"
      >
        {{ fileExists ? "Add More Files" : "Add File" }}
      </button>
      <button
        *ngIf="fileExists"
        type="button"
        class="w-full sm:w-72 h-12 flex items-center justify-center rounded-lg border border-gray-400"
        (click)="download(uploadedFiles[0])"
      >
        Preview File Utama
      </button>
      <div
        *ngIf="uploadedFiles.length"
        class="w-full sm:w-72 rounded-lg border border-gray-200 p-2 flex flex-col gap-2"
      >
        <span class="text-xs font-medium text-[#5C5C5C]">Uploaded Files</span>
        <div
          *ngFor="let item of uploadedFiles; let i = index"
          class="flex items-center justify-between gap-2 rounded border border-gray-200 px-2 py-1"
        >
          <span class="text-xs text-[#5C5C5C] truncate">{{ item.fileName }}</span>
          <div class="flex items-center gap-2 shrink-0">
            <button
              type="button"
              (click)="download(item)"
              class="text-xs text-[#42A5CE]"
            >
              Preview
            </button>
            <button
              type="button"
              (click)="removeUploadedFile(i)"
              class="text-xs text-red-500"
            >
              Remove
            </button>
          </div>
        </div>
      </div>
      <span class="text-xs w-full sm:w-72"
        >Support file extension (jpg, png, jpeg, bmp, pdf, xls, xlsx, doc,
        docx) - multi upload supported</span
      >
    </div>
  </form>
</section>
